// Contact Form 7 configuration for Tariefcalculator integration
// Fill in these values as needed for your WordPress setup

const cf7Config = {
  formNr: '2836', // e.g. '1234' local '36654'
  containerPost: '481', // e.g. '5678'
  formId: 'wpcf7-f2836-p481-o1', // e.g. 'wpcf7-f1234-p5678-o1'
  wpcf7Version: '5.5.6',
  wpcf7Locale: 'nl_NL',
};

export default cf7Config; 